// extracted by mini-css-extract-plugin
export default {"table-layout":"LegalEntityTable_table-layout__06Z-H","operate":"LegalEntityTable_operate__j1VQs","icon-3-dots":"LegalEntityTable_icon-3-dots__egpCk"};